// File validation constants and utilities
export const FILE_VALIDATION_CONFIG = {
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB in bytes
  ALLOWED_EXTENSIONS: ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt',  'md', 'rtf', 'png', 'jpg', 'jpeg', 'gif', 'py', 'js', 'jsx', 'ts', 'tsx',   'java', 'cpp', 'c', 'cs', 'php', 'rb', 'go', 'sql', 'html', 'css', 'scss', 'less',  'json', 'xml', 'yaml', 'yml'],
  MAX_TOTAL_SIZE: 50 * 1024 * 1024 // 50MB total
};

// Export individual constants for backward compatibility
export const MAX_FILE_SIZE = FILE_VALIDATION_CONFIG.MAX_FILE_SIZE;
export const ALLOWED_EXTENSIONS = FILE_VALIDATION_CONFIG.ALLOWED_EXTENSIONS;
export const MAX_TOTAL_SIZE = FILE_VALIDATION_CONFIG.MAX_TOTAL_SIZE;

/**
 * Validates an array of files against size and extension restrictions
 * @param {File[]} files - Array of files to validate
 * @returns {Object} - Validation result with isValid flag and errors array
 */
export const validateFiles = (files) => {
  const { MAX_FILE_SIZE, ALLOWED_EXTENSIONS, MAX_TOTAL_SIZE } = FILE_VALIDATION_CONFIG;
  
  const errors = [];
  let totalSize = 0;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    totalSize += file.size;

    // Check file size
    if (file.size > MAX_FILE_SIZE) {
      errors.push(`${file.name} is too large (${(file.size / (1024*1024)).toFixed(1)}MB). Maximum allowed size is ${MAX_FILE_SIZE / (1024*1024)}MB`);
    }

    // Check if file is empty
    if (file.size === 0) {
      errors.push(`${file.name} is empty`);
    }

    // Check file extension
    const extension = file.name.split('.').pop()?.toLowerCase();

    console.log(`Validating file: ${file.name}, size: ${file.size} bytes, extension: ${extension}`);
    console.log('validation condition - extension:', extension, 'allowed:', ALLOWED_EXTENSIONS.includes(extension));

    if (!extension || !ALLOWED_EXTENSIONS.includes(extension)) {
      errors.push(`${file.name} has an invalid file type. Allowed types: ${ALLOWED_EXTENSIONS.join(', ')}`);
    }
  }

  // Check total upload size
  if (totalSize > MAX_TOTAL_SIZE) {
    errors.push(`Total upload size (${(totalSize / (1024*1024)).toFixed(1)}MB) exceeds maximum allowed (${MAX_TOTAL_SIZE / (1024*1024)}MB)`);
  }

  return {
    isValid: errors.length === 0,
    errors: errors,
    totalSize: totalSize
  };
};

/**
 * Formats file size in human-readable format
 * @param {number} bytes - File size in bytes
 * @returns {string} - Formatted file size
 */
export const formatFileSize = (bytes) => {
  if (!bytes) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};